import { get } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [updateUserAuth] = useMutation(graphql.mutations.UPDATE_USER_AUTH);
  const [updateUser] = useMutation(graphql.mutations.UPDATE_USER, {
    refetchQueries: [
      {
        query: graphql.queries.ORGANIZATION,
        awaitRefetchQueries: true,
        variables: { where: { id } },
      },
    ],
  });

  const { data, loading } = useQuery(graphql.queries.ORGANIZATION, {
    variables: { where: { id } },
  });

  const onBack = () => {
    navigate(SCREENS.PRIVATE.ADMIN.COMPANIES.LIST.path);
  };

  const onSubmit = ({ organization, user }) => {
    if (user.id) {
      updateUserAuth({
        variables: {
          where: { id: user.id },
          data: {
            username: user.email,
            email: user.email,
            phone: user.phone,
          },
        },
        onCompleted: () => {
          updateUser({
            variables: {
              where: { id: user.id },
              data: {
                username: user.email,
                email: user.email,
                phone: user.phone,
                firstname: user.firstname,
                lastname: user.lastname,
                organization,
              },
            },
          });
        },
      });
    }
  };

  if (loading) return <Loading />;

  return (
    <View
      onSubmit={onSubmit}
      enterprise={omitDeep(get(data, "organization", {}), "__typename")}
      onBack={onBack}
    />
  );
};

export default Detail;
